import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {
  ExchangeMaturityRejectionRuleService
} from "../../../services/exchange/exchange-maturity-rejection-rule.service";
import {MaturityRejectionRule} from "../../../model/exchange/maturity-rejection-rule";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-maturity-rej-rule',
  templateUrl: './maturity-rejection-rule.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class MaturityRejectionRuleComponent extends CrudBaseComponent<MaturityRejectionRule> {

  //fields
  clearingHouses: FieldRecord<any>[]
  rules: FieldRecord<any>[]
  exchanges: FieldRecord<any>[]
  displayedExchangeCodes: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              maturityRejectionRuleService: ExchangeMaturityRejectionRuleService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = maturityRejectionRuleService;
    this.newRecord = new MaturityRejectionRule();
    this.newRecord.exchangeCode = ExchangeDetail.ALL;
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.id = -1;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'clearingHouse',
        width: 130
      },
      {
        field: 'exchangeCode',
        width: 150,
        mapId: record => !record.exchangeCode || record.exchangeCode === ExchangeDetail.ALL ? ExchangeDetail.ALL_TEXT : record.exchangeCode,
        icon: (record: any) => {
          const exchField = this.exchanges ? this.exchanges.find(field => field.value
            && field.value.code === record.exchangeCode) : undefined;
          if (exchField && exchField.value) {
            return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          } else {
            return 'fas fa-globe-europe';
          }
        }
      },
      {
        field: 'type',
        width: 100,
      },
      {
        field: 'contractList',
        width: 100,
      },
      {
        field: 'maturity',
        width: 100,
      },
      {
        field: 'brokerCode',
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'clearingHouse',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.clearingHouses,
            changed: event => this.filterExchanges()
          },
          {
            field: 'exchangeCode',
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.displayedExchangeCodes,
            icon: (ig: any) => {
              const exchField = this.displayedExchangeCodes.find(field => field.value && field.value.code === ig);
              if (exchField && exchField.value) {
                return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              } else {
                return 'fas fa-globe-europe';
              }
            },
            optionValue: 'id'
          },
          {
            field: 'enabled',
            column: 4,
            type: TYPE.CHECKBOX
          },
          {
            field: 'brokerCode',
            required: true,
            column: 4,
            type: TYPE.TEXT
          },
          {
            field: 'maturity',
            required: true,
            column: 4,
            type: TYPE.TEXT
          },
          {
            field: 'type',
            required: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.rules,
          },
          {
            field: 'allFutures',
            column: 2,
            type: TYPE.CHECKBOX
          },
          {
            field: 'allOptions',
            column: 2,
            type: TYPE.CHECKBOX
          },
          {
            field: 'contractListInclude',
            column: 2,
            type: TYPE.CHECKBOX
          },
          {
            field: 'contractList',
            column: 6,
            type: TYPE.TEXT
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;
    this.commonFieldService.getClearingHouses(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.clearingHouses = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 2;
    });

    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      // let defaultAllExchange = FieldRecord.DEFAULT();
      // defaultAllExchange.text = this.translateService.instant('page.account.form.defaultExchangeAll');
      // defaultAllExchange.id = ExchangeDetail.ALL;
      // this.exchanges.unshift(defaultAllExchange);
      this.filterExchanges();
      this.settingsFormLoadingProgressValue += 100 / 2;
    });

    this.rules = [];
    for (let key in MaturityRejectionRule.MaturityRejectionRuleType) {
      this.rules.push(new FieldRecord(key, key.toLowerCase()))
    }
  }

  private filterExchanges() {
    let defaultAllExchange = FieldRecord.DEFAULT();
    defaultAllExchange.text = this.translateService.instant('page.account.form.defaultExchangeAll');
    defaultAllExchange.id = ExchangeDetail.ALL;
    if (this.exchanges && this.formRecord) {
      this.displayedExchangeCodes = this.exchanges.filter(field => this.formRecord.clearingHouse && field.value && this.formRecord.clearingHouse === field.value.clearingHouse);
      this.displayedExchangeCodes.unshift(defaultAllExchange);
      if (this.displayedExchangeCodes.filter(value => value.id === this.formRecord.exchangeCode).length == 0)
        this.formRecord.exchangeCode = ExchangeDetail.ALL;
    } else {
      this.displayedExchangeCodes = [defaultAllExchange];
    }
  }

  onFormShow() {
    this.filterExchanges();
  }
}
